<template>
    <v-container
        class="pa-0 category-wrapper"
    >
        <div
            v-if="loading"
            class="d-flex flex-column gap-2"
        >
            <v-skeleton-loader
                type="list-item"
                v-for="n in 20"
                :key="n"
            >
            </v-skeleton-loader>
        </div>
        <div
            v-else
            class="d-flex flex-column gap-2"
        >
            <v-btn
                v-for="(cat, index) in categories"
                :key="index"
                color="secondary"
                outlined
                height="34"
                class="w-100"
            >
                <span>{{ cat.name }}</span>
            </v-btn>
        </div>

    </v-container>
</template>

<script>
export default {
  props: {
    fetchAllProducts: Boolean
  },
  data () {
    return {
      categories: null,
      loading: false
    }
  },
  mounted () {
    this.fetchProductsCategory()
  },
  methods: {
    fetchProductsCategory () {
      var app = this
      app.loading = true
      app.$emit('loadingStatus', app.loading)
      app.$axios.get(this.$endpoint + 'productpageshortcut', {
        params: {
          type: 'page',
          page: 1
        }
      })
        .then(r => {
          this.categories = r.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
          app.$emit('loadingStatus', app.loading)
        })
    }
  },
  watch: {
    fetchAllProducts (val) {
      if (val) {
        this.fetchProductsCategory()
        this.$emit('productsFetched')
      }
    }
  }
}
</script>

<style>
.category-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 0;
    overflow-y: auto;
}
.theme--light::-webkit-scrollbar {
    display: none !important;
}

.theme--light::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-left: 1px solid #dadada;
}

.theme--light::-webkit-scrollbar-thumb {
    background-color: rgb(100, 96, 96);
    border: solid 3px #e6e6e6;
    border-radius: 7px;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text,
.v-skeleton-loader__list-item {
  height: 30px;
}
</style>
